import { jsx as c } from "react/jsx-runtime";
import { c as i } from "react/compiler-runtime";
import { Stack as p } from "@mui/material";
import { forwardRef as s } from "react";
const l = s((m, a) => {
  const t = i(7);
  let o, r;
  t[0] !== m ? ({
    children: o,
    ...r
  } = m, t[0] = m, t[1] = o, t[2] = r) : (o = t[1], r = t[2]);
  let e;
  return t[3] !== o || t[4] !== r || t[5] !== a ? (e = /* @__PURE__ */ c(p, { ref: a, ...r, children: o }), t[3] = o, t[4] = r, t[5] = a, t[6] = e) : e = t[6], e;
});
l.displayName = "Stack";
export {
  l as Stack
};
